import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, assetUrl } from "@/lib/api";
import { Star, CaretRight } from "@phosphor-icons/react";
import ShareButton from "@/components/ShareButton";

export default function EditorsPicks() {
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    api.get("/public/editors-picks").then((r) => setPhotos(r.data.photos || [])).catch(() => {});
  }, []);
  if (!photos.length) return null;
  return (
    <section className="mx-auto max-w-6xl px-5 pt-10" data-testid="editors-picks">
      <div className="mb-3 flex items-center gap-2">
        <Star size={20} weight="fill" className="text-amber-500" />
        <h2 className="font-display text-xl font-black tracking-tight sm:text-2xl">Editor&apos;s Picks</h2>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 [scrollbar-width:thin]">
        {photos.map((p) => (
          <Link key={p.id} to={`/p/${p.id}`} data-testid={`editors-pick-${p.id}`}
            className="group relative h-52 w-72 shrink-0 overflow-hidden rounded-xl bg-zinc-100 ring-1 ring-amber-400/40">
            <img src={assetUrl(p.image_url)} alt={p.title || "photo"} loading="lazy"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-full bg-amber-500 px-2 py-0.5 text-[10px] font-bold text-white shadow">
              <Star size={10} weight="fill" /> Pick
            </span>
            <div className="absolute right-2.5 top-2.5 opacity-100 transition-opacity duration-300 md:opacity-0 md:group-hover:opacity-100">
              <ShareButton id={p.id} title={p.title} />
            </div>
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-3">
              <p className="line-clamp-1 text-sm font-bold text-white">{p.title || "Untitled"}</p>
              {p.location?.city && (
                <p className="line-clamp-1 text-xs text-white/80">
                  {p.location.city}{p.location.country ? `, ${p.location.country}` : ""}
                </p>
              )}
            </div>
          </Link>
        ))}
      </div>
      <Link to="/explore" className="mt-1 inline-flex items-center gap-0.5 text-sm font-bold text-[#F27A54] hover:underline">
        Explore the full gallery <CaretRight size={14} weight="bold" />
      </Link>
    </section>
  );
}
